import { pick } from '@styled-system/props';
import { ReactNode } from 'react';
import { CheckablesLabel } from './useCheckablesLabel';
import { Box, BoxOptions, BoxProps } from '../../Box/Box';
import { Stack } from '../../Stack/Stack';

type Props = {
  hasError?: boolean;
  disabled?: boolean;
  label?: ReactNode;
  hint?: ReactNode;
  inputType: 'Checkbox' | 'Radiobutton';
} & BoxProps &
  BoxOptions;

export function CheckablesWrapper({
  hasError,
  disabled,
  label,
  hint,
  inputType,
  width,
  ...props
}: Props) {
  const styledProps: BoxOptions = pick(props);
  let iconStyle: 'base' | 'error' | 'disabled' = 'base';
  if (hasError) iconStyle = 'error';
  if (disabled) iconStyle = 'disabled';

  return (
    <CheckablesLabel
      disabled={disabled}
      width={width}
      kind={iconStyle}
      label={inputType}
      as={label ? 'label' : 'div'}
    >
      <Box
        position="relative"
        display="inline-flex"
        alignContent="center"
        alignItems="center"
        alignSelf="flex-start"
        flexShrink={0}
        flexGrow={0}
        py="sp-2"
        marginRight="sp-12"
        {...styledProps}
      >
        {props.children}
      </Box>
      <Stack space="sp-4">
        {label && <Box as="span">{label}</Box>}
        {hint && (
          <Box as="span" className="hint">
            {hint}
          </Box>
        )}
      </Stack>
    </CheckablesLabel>
  );
}
